import styled from "styled-components";

const Row = styled.div`
position: relative;
width: 100vw;
padding: 10px;
display: flex;
flex-direction: row;
align-items: center;
justify-content: space-around;
`;

export default Row;